// list of custom component aliases
// from object keys of customComponents

enum CustomComponentName {
  'Accordion' = 'Accordion',
  'AccordionDetails' = 'AccordionDetails',
  'AccordionSummary' = 'AccordionSummary',
  'Alert' = 'Alert',
  'AlertTitle' = 'AlertTitle',
  'Banner' = 'Banner',
  'BaseAccordion' = 'BaseAccordion',
  'BrowseSampleCard' = 'BrowseSampleCard',
  'Button' = 'Button',
  'ButtonGroup' = 'ButtonGroup',
  'Card' = 'Card',
  'CardActions' = 'CardActions',
  'CardContent' = 'CardContent',
  'CardHeader' = 'CardHeader',
  'CardMedia' = 'CardMedia',
  'Chip' = 'Chip',
  'ColorSwatch' = 'ColorSwatch',
  'Container' = 'Container',
  'Divider' = 'Divider',
  'DownloadStudioButton' = 'DownloadStudioButton',
  'ExpertSection' = 'ExpertSection',
  'Grid' = 'Grid',
  'GridContainer' = 'GridContainer',
  'HomePageCategoryListingCard' = 'HomePageCategoryListingCard',
  'HomePageNewsCard' = 'HomePageNewsCard',
  'HomePageTopicCard' = 'HomePageTopicCard',
  'InlineCode' = 'InlineCode',
  'KeyboardInput' = 'KeyboardInput',
  'Link' = 'Link',
  'Loader' = 'Loader',
  'LuaCode' = 'LuaCode',
  'ScriptingLibrariesCard' = 'ScriptingLibrariesCard',
  'SideBarLink' = 'SideBarLink',
  'StickyFooter' = 'StickyFooter',
  'Step' = 'Step',
  'StepButton' = 'StepButton',
  'StepConnector' = 'StepConnector',
  'StepContent' = 'StepContent',
  'StepLabel' = 'StepLabel',
  'Stepper' = 'Stepper',
  'ScopeTable' = 'ScopeTable',
  'SwaggerDocs' = 'SwaggerDocs',
  'TabItem' = 'TabItem',
  'Tabs' = 'Tabs',
  'Table' = 'Table',
  'TableCell' = 'TableCell',
  'TableBody' = 'TableBody',
  'TableFooter' = 'TableFooter',
  'TableHead' = 'TableHead',
  'TablePagination' = 'TablePagination',
  'TableRow' = 'TableRow',
  'TableSortLabel' = 'TableSortLabel',
  'Tooltip' = 'Tooltip',
  'Translation' = 'Translation',
  'Typography' = 'Typography',
  'UseStudioButton' = 'UseStudioButton',
}

export type CustomMDXComponentName = keyof typeof CustomComponentName;

// transform typescript enum to array of strings
export const CustomComponentNames = Object.values(CustomComponentName) as CustomMDXComponentName[];

export default CustomComponentName;
